import {params_with_csrf_token} from 'utils/form_utils'

export xhr_get = (url, success = null) -> xhr(url, 'GET', null, success)

export xhr = (url, method = 'POST', body = null, success = null) ->
  body = params_with_csrf_token() if body == null and method != 'GET'
  headers = { 'X-Requested-With': 'XMLHttpRequest' }
  fetch(url, method: method, body: body, headers: headers).then (response) -> 
    success(response) if success